import { render, staticRenderFns } from "./researchOriginData.vue?vue&type=template&id=fbc6caa6&scoped=true"
import script from "./researchOriginData.vue?vue&type=script&lang=js"
export * from "./researchOriginData.vue?vue&type=script&lang=js"
import style0 from "./researchOriginData.vue?vue&type=style&index=0&id=fbc6caa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbc6caa6",
  null
  
)

export default component.exports